import styled from "styled-components";

export const Heading = styled.div`
  font-family: "latobold";
  font-size: 17px;
    line-height: 36px;
  &.text-center {
    text-align: center;
  }
`;

export const SubHeading = styled.div`
line-height: 24px;
margin-bottom: 20px;
font-size: 16px;
margin-bottom: 20px;
  &.text-center {
    text-align: center;
  }
`;
export const TickSignWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const OTPWrapper = styled.div`
    width: 100%;
    max-width: 430px;
    margin: 0 auto;
`